// Données des pages ville (cercle 1) — DS Serrurier Urgence
// Chaque ville a un angle éditorial différencié pour éviter le duplicate content.

export const VILLES = [
  {
    slug: "puteaux",
    nom: "Puteaux",
    codePostal: "92800",
    departement: "92",
    departementNom: "Hauts-de-Seine",
    angle: "Notre base d'astreinte est à Puteaux",
    tagline: "Notre ville d'ancrage",
    heroSubtitle: "Puteaux est notre point d'ancrage : notre base d'astreinte y est installée. Au téléphone, nous vous confirmons notre disponibilité et un délai estimé selon votre adresse et l'heure.",
    intro:
      "DS Serrurier Urgence est implanté à Puteaux (92800) : c'est ici que se trouvent notre base d'astreinte et notre matériel. Pour les Putéoliens, les trajets sont courts. Nous sommes joignables à toute heure du jour et de la nuit, dimanches et jours fériés compris, et nous vous indiquons au téléphone un délai estimé, sans promesse de délai fixe.",
    contextLocal:
      "Nous intervenons dans tous les quartiers de Puteaux : centre-ville, quartier du théâtre, Bergères, Rose-de-Cherbourg, ainsi que dans les immeubles bordant le boulevard circulaire de La Défense. Copropriétés, pavillons, locaux professionnels : nos techniciens sont familiers du parc immobilier local.",
    servicesFocus: ["ouverture-porte", "blindage", "changement-serrure", "vitrerie", "volets", "controle-acces"],
    limitrophes: ["courbevoie", "suresnes", "nanterre", "neuilly-sur-seine", "la-defense"],
    image: "/images/villes/puteaux.webp",
    imageWidth: 900,
    imageHeight: 549,
    imageAlt: "Vue de la ville de Puteaux, Hauts-de-Seine, zone d'intervention DS Serrurier",
    seoTitle: "Serrurier Puteaux (92800) 7j/7 | DS Serrurier",
    seoDescription: "Serrurier à Puteaux (92800) : base d'astreinte sur place, délai estimé à l'appel. Ouverture, blindage, vitrerie, volets, contrôle d'accès. Devis gratuit.",
    servicesIntro: "Basés à Puteaux, nous intervenons sur ces 4 domaines avec des trajets courts, en urgence comme en projet planifié.",
    servicesNotes: {
      "serrurerie-securite": "Ouverture, blindage et pose de cylindre A2P, depuis notre base de Puteaux.",
      "vitrerie": "Vitre cassée ou vitrage de sécurité : intervention depuis notre base toute proche.",
      "volets-roulants": "Volet bloqué ou moteur en panne : diagnostic et dépannage du volet ou de son moteur.",
      "controle-acces": "Digicodes et badges pour copropriétés et locaux professionnels du centre-ville.",
    },
    ctaLine: "Notre base est à Puteaux : appelez-nous pour un délai estimé.",
    situations: [
      { titre: "Porte claquée, clés à l'intérieur", texte: "Ouverture de la porte en privilégiant les techniques sans casse, puis vérification du bon fonctionnement de la serrure avant de repartir." },
      { titre: "Serrure bloquée, clé qui ne tourne plus", texte: "Diagnostic du cylindre et du mécanisme : réparation lorsque c'est possible, remplacement de la pièce en cause sinon." },
      { titre: "Perte ou vol de clés", texte: "Remplacement du cylindre pour qu'aucune ancienne clé ne puisse plus ouvrir, avec un modèle certifié A2P sur demande." },
      { titre: "Après une effraction", texte: "Remise en état de la fermeture pour sécuriser le logement le jour même lorsque c'est faisable, puis devis pour un renforcement si nécessaire." },
    ],
    realisations: [
      {
        id: "puteaux-cylindre-heracles",
        titre: "Remplacement d'un cylindre après une perte de clés",
        lieu: "Puteaux",
        probleme: "Après une perte de clés, le client voulait sécuriser à nouveau l'accès à son logement.",
        solution: "Remplacement à l'identique du cylindre existant par un cylindre Heracles Sésame certifié A2P* (une étoile).",
        resultat: "Le logement est de nouveau sécurisé : la clé perdue n'ouvre plus la porte.",
        service: "serrurerie-securite",
        photos: [
          {
            src: "/images/realisations/puteaux-cylindre-heracles-sesame-a2p",
            widths: [480, 912],
            width: 912,
            height: 502,
            alt: "Cylindre de serrure Heracles Sésame portant le marquage A2P une étoile, tenu en main",
            legende: "Le cylindre Heracles Sésame et son marquage A2P*.",
          },
          {
            src: "/images/realisations/puteaux-cylindre-heracles-goupilles",
            widths: [480, 922],
            width: 922,
            height: 481,
            alt: "Face latérale du cylindre Heracles Sésame montrant ses rangées de goupilles",
            legende: "Face du cylindre côté goupilles.",
          },
        ],
      },
    ],
  },
  {
    slug: "nanterre",
    nom: "Nanterre",
    codePostal: "92000",
    departement: "92",
    departementNom: "Hauts-de-Seine",
    angle: "Préfecture des Hauts-de-Seine — mix résidentiel & administratif",
    tagline: "Copropriétés & grands ensembles",
    heroSubtitle: "À Nanterre, nous intervenons aussi bien dans les grandes copropriétés du Petit-Nanterre et du Parc que dans les pavillons du Vieux-Pays et les locaux administratifs du centre-ville.",
    intro:
      "Nanterre concentre une diversité d'habitats rare en Île-de-France : grands ensembles verticaux, résidences en copropriété, pavillonnaire, et parc administratif lié à la préfecture. Cette diversité impose au serrurier une bonne connaissance des systèmes de fermeture les plus courants comme des installations plus techniques (portes palières blindées collectives, VIGIK, badges d'immeuble).",
    contextLocal:
      "Nos interventions à Nanterre couvrent tous les quartiers : Petit-Nanterre, Parc Sud, Université, Vieux-Pays, Plateau Mont-Valérien, ainsi que le quartier des Terrasses. Nous travaillons régulièrement pour des syndics de copropriété et pouvons établir des devis pour la réfection collective de systèmes de fermeture.",
    servicesFocus: ["ouverture-porte", "changement-serrure", "vitrerie", "controle-acces", "blindage", "volets"],
    limitrophes: ["puteaux", "courbevoie", "suresnes", "la-defense"],
    image: "/images/villes/nanterre.webp",
    imageWidth: 927,
    imageHeight: 560,
    imageAlt: "Vue de la ville de Nanterre, Hauts-de-Seine, zone d'intervention DS Serrurier",
    seoTitle: "Serrurier Nanterre (92000) 7j/7 | DS Serrurier",
    seoDescription: "Serrurier à Nanterre (92000) : mix résidentiel et administratif, préfecture des Hauts-de-Seine. Ouverture, blindage, vitrerie, volets. Devis gratuit.",
    servicesIntro: "Du grand ensemble au pavillon du Vieux-Pays, nos 4 domaines s'adaptent à la diversité du bâti nanterrien.",
    servicesNotes: {
      "serrurerie-securite": "Ouverture et blindage adaptés aux portes palières collectives comme aux pavillons.",
      "vitrerie": "Remplacement de vitre et vitrage de sécurité pour tous types de logements.",
      "volets-roulants": "Dépannage de volet, du grand ensemble à la maison individuelle.",
      "controle-acces": "VIGIK et badges d'immeuble pour les grandes copropriétés nanterriennes.",
    },
    ctaLine: "Nous connaissons vos quartiers, appelez-nous.",
    situations: [
      { titre: "Porte palière claquée", texte: "Ouverture de la porte d'appartement, en immeuble collectif comme en résidence, en privilégiant les techniques sans casse." },
      { titre: "Serrure bloquée ou en applique grippée", texte: "Démontage et réparation du mécanisme lorsque les pièces le permettent, plutôt qu'un remplacement complet de la serrure." },
      { titre: "Clés perdues ou cylindre défaillant", texte: "Remplacement du seul cylindre quand la serrure elle-même est en bon état." },
      { titre: "Copropriétés et syndics", texte: "Devis pour les portes d'immeuble, contrôles d'accès VIGIK et badges, et la réfection collective des fermetures." },
    ],
    realisations: [
      {
        id: "nanterre-fichet-690",
        titre: "Réparation d'une serrure Fichet 690 Sans Souci bloquée",
        lieu: "Nanterre",
        probleme: "La serrure de sécurité Fichet 690 Sans Souci de la porte d'entrée était bloquée.",
        diagnostic: "La serrure pouvait être conservée : seuls le cylindre et des pièces d'usure du mécanisme étaient à remplacer.",
        solution: "Remplacement du cylindre et des pièces d'usure nécessaires, puis remontage du mécanisme sur la porte.",
        resultat: "La serrure existante fonctionne de nouveau, sans avoir eu à la remplacer entièrement.",
        service: "serrurerie-securite",
        photos: [
          {
            src: "/images/realisations/nanterre-fichet-690-boitier-ouvert",
            widths: [480, 670],
            width: 670,
            height: 1120,
            alt: "Boîtier ouvert d'une serrure en applique Fichet 690 Sans Souci, sans cylindre",
            legende: "Le boîtier de la serrure Fichet 690, ouvert.",
          },
          {
            src: "/images/realisations/nanterre-fichet-690-mecanisme-cylindre",
            widths: [480, 640],
            width: 640,
            height: 1140,
            alt: "Mécanisme interne de la serrure Fichet 690 avec ses pièces de manœuvre et un cylindre en place",
            legende: "Le mécanisme avec un cylindre en place (clés floutées).",
          },
          {
            src: "/images/realisations/nanterre-fichet-690-piece-interne",
            widths: [480, 620],
            width: 620,
            height: 880,
            alt: "Pièce métallique interne du mécanisme de la serrure Fichet 690 tenue en main",
            legende: "Une pièce interne du mécanisme.",
          },
        ],
      },
    ],
  },
  {
    slug: "courbevoie",
    nom: "Courbevoie",
    codePostal: "92400",
    departement: "92",
    departementNom: "Hauts-de-Seine",
    angle: "Contrôle d'accès & locaux d'entreprise",
    tagline: "Bureaux & abords de La Défense",
    heroSubtitle: "Courbevoie borde immédiatement le quartier d'affaires de La Défense. Nous sommes spécialisés dans la sécurisation de locaux d'entreprise, cabinets et commerces.",
    intro:
      "À Courbevoie, l'activité serrurerie prend souvent une dimension professionnelle : cabinets d'avocats, agences, commerces de la rue de Bezons ou de la rue du Général de Gaulle, plateaux de bureaux à proximité immédiate de La Défense. Nous accompagnons ces établissements sur les problématiques de contrôle d'accès, gestion des clés, et sécurisation post-effraction.",
    contextLocal:
      "Nos interventions couvrent le centre-ville, Bécon, Faubourg de l'Arche, Cœur de Ville, et les abords de La Défense. Nous proposons des systèmes adaptés à un usage tertiaire (badges programmables, cylindres à passe organigramme, digicodes) et travaillons en coordination avec les gardiens d'immeuble.",
    servicesFocus: ["controle-acces", "changement-serrure", "blindage", "ouverture-porte", "vitrerie", "volets"],
    limitrophes: ["puteaux", "la-defense", "neuilly-sur-seine", "nanterre"],
    image: "/images/villes/courbevoie.webp",
    imageWidth: 900,
    imageHeight: 750,
    imageAlt: "Vue de la ville de Courbevoie, Hauts-de-Seine, zone d'intervention DS Serrurier",
    seoTitle: "Serrurier Courbevoie (92400) 7j/7 | DS Serrurier",
    seoDescription: "Serrurier à Courbevoie (92400) : contrôle d'accès, badges, bureaux et locaux d'entreprise. Ouverture, blindage, vitrerie, volets. Devis gratuit.",
    servicesIntro: "Aux abords de La Défense, nos 4 domaines couvrent aussi bien les locaux professionnels que les logements.",
    servicesNotes: {
      "serrurerie-securite": "Ouverture et sécurisation pour cabinets, agences et commerces du centre-ville.",
      "vitrerie": "Vitre brisée ou vitrage de sécurité pour vitrines et bureaux.",
      "volets-roulants": "Dépannage de volet pour logements et locaux commerciaux.",
      "controle-acces": "Badges programmables et digicodes pour un usage tertiaire au quotidien.",
    },
    ctaLine: "Cabinets, commerces, logements : appelez-nous pour un délai estimé.",
    situations: [
      { titre: "Porte d'appartement claquée ou fermée à clé", texte: "Les particuliers de Courbevoie nous appellent aussi pour une ouverture de porte, en privilégiant les techniques sans casse." },
      { titre: "Changement de cylindre", texte: "Après une perte de clés, un déménagement ou un cylindre usé, avec un modèle certifié A2P sur demande." },
      { titre: "Bureaux, cabinets et commerces", texte: "Contrôle d'accès, badges, digicodes et gestion des clés pour les locaux professionnels." },
      { titre: "Après une effraction", texte: "Sécurisation de la porte puis devis pour la remise en état ou le renforcement." },
    ],
  },
  {
    slug: "suresnes",
    nom: "Suresnes",
    codePostal: "92150",
    departement: "92",
    departementNom: "Hauts-de-Seine",
    angle: "Pavillons & blindage de porte",
    tagline: "Pavillonnaire & maisons individuelles",
    heroSubtitle: "Suresnes offre un tissu majoritairement résidentiel avec de nombreuses maisons individuelles. Le blindage de porte et le renforcement de menuiseries y sont nos interventions les plus fréquentes.",
    intro:
      "À Suresnes, nos clients sont majoritairement des propriétaires de pavillons ou d'appartements en petite copropriété. Après une tentative d'effraction, ou dans une démarche préventive, nombreux sont ceux qui investissent dans un blindage de porte d'entrée, un cylindre A2P, ou une porte blindée complète. Nous conseillons et posons en respectant les contraintes esthétiques des maisons anciennes.",
    contextLocal:
      "Nous intervenons dans tous les secteurs de Suresnes : Cité-Jardin, Mont-Valérien, Centre-Ville, République, Liberté. Suresnes étant située sur les hauteurs, nos équipes connaissent bien les accès résidentiels parfois délicats (voies étroites, jardins clos) et adaptent leur intervention en conséquence.",
    servicesFocus: ["blindage", "changement-serrure", "ouverture-porte", "volets", "vitrerie", "controle-acces"],
    limitrophes: ["puteaux", "nanterre", "la-defense"],
    image: "/images/villes/suresnes.webp",
    imageWidth: 1280,
    imageHeight: 717,
    imageAlt: "Vue de la ville de Suresnes, Hauts-de-Seine, zone d'intervention DS Serrurier",
    seoTitle: "Serrurier Suresnes (92150) 7j/7 | DS Serrurier",
    seoDescription: "Serrurier à Suresnes (92150) : pavillons, maisons individuelles et blindage de porte. Ouverture, vitrerie, volets, contrôle d'accès. Devis gratuit.",
    servicesIntro: "Pensés pour le pavillonnaire suresnois, nos 4 domaines privilégient le renforcement et la discrétion.",
    servicesNotes: {
      "serrurerie-securite": "Blindage de porte et cylindre A2P, adaptés aux maisons anciennes.",
      "vitrerie": "Vitre cassée ou vitrage retardateur d'effraction pour votre pavillon.",
      "volets-roulants": "Dépannage et motorisation de volets sur maison individuelle.",
      "controle-acces": "Digicode et interphone pour sécuriser l'accès à votre propriété.",
    },
    ctaLine: "Un serrurier qui connaît vos maisons individuelles.",
    situations: [
      { titre: "Porte d'entrée de maison bloquée", texte: "Ouverture et diagnostic de la serrure, souvent multipoint sur les maisons individuelles." },
      { titre: "Renforcer une porte existante", texte: "Blindage de la porte, cylindre et serrure certifiés A2P, après une tentative d'effraction ou par prévention." },
      { titre: "Appartement en petite copropriété", texte: "Ouverture de porte claquée et changement de cylindre après une perte de clés." },
      { titre: "Volet roulant bloqué", texte: "Dépannage du volet ou de son moteur, pour ne pas laisser une ouverture de la maison mal fermée." },
    ],
  },
  {
    slug: "neuilly-sur-seine",
    nom: "Neuilly-sur-Seine",
    codePostal: "92200",
    departement: "92",
    departementNom: "Hauts-de-Seine",
    angle: "Discrétion & service haut de gamme",
    tagline: "Confidentialité & prestations premium",
    heroSubtitle: "À Neuilly-sur-Seine, nous adaptons notre intervention à un cadre résidentiel exigeant : discrétion, respect des menuiseries d'époque, et matériel de haute sécurité.",
    intro:
      "Les interventions à Neuilly-sur-Seine se distinguent par leur exigence : appartements haussmanniens, hôtels particuliers, portes d'origine à préserver, systèmes de sécurité multi-points de dernière génération. Nous choisissons pour chaque chantier du matériel adapté (Fichet, Mul-T-Lock, Bricard) et travaillons dans le respect absolu du bien et de la vie privée de nos clients.",
    contextLocal:
      "Nous couvrons l'ensemble de Neuilly : avenue Charles de Gaulle, Sablons, Saint-James, avenue du Roule, île de la Jatte. Nos techniciens sont habitués à intervenir en présence de gardiens d'immeuble, à respecter les protocoles d'entrée des résidences sécurisées, et à travailler sans laisser de trace visible sur les huisseries.",
    servicesFocus: ["blindage", "changement-serrure", "controle-acces", "ouverture-porte", "vitrerie", "volets"],
    limitrophes: ["puteaux", "courbevoie", "la-defense"],
    image: "/images/villes/neuilly-sur-seine.webp",
    imageWidth: 1024,
    imageHeight: 1024,
    imageAlt: "Vue de la ville de Neuilly-sur-Seine, Hauts-de-Seine, zone d'intervention DS Serrurier",
    seoTitle: "Serrurier Neuilly-sur-Seine 7j/7 | DS Serrurier",
    seoDescription: "Serrurier à Neuilly-sur-Seine (92200) : discrétion et service haut de gamme. Ouverture, blindage, vitrerie, volets. Devis gratuit.",
    servicesIntro: "Nos 4 domaines s'exercent avec la discrétion attendue dans un cadre résidentiel haussmannien.",
    servicesNotes: {
      "serrurerie-securite": "Blindage et cylindres haute sécurité (Fichet, Mul-T-Lock) posés sans trace visible.",
      "vitrerie": "Vitrage de sécurité posé dans le respect des menuiseries d'époque.",
      "volets-roulants": "Motorisation de volet, discrète et adaptée aux façades classées.",
      "controle-acces": "Contrôle d'accès pour résidences sécurisées, en coordination avec le gardien.",
    },
    ctaLine: "Discrétion et matériel haut de gamme, sur rendez-vous ou en urgence.",
  },
  {
    slug: "la-defense",
    nom: "La Défense",
    codePostal: "92800",
    departement: "92",
    departementNom: "Hauts-de-Seine",
    angle: "Quartier d'affaires multi-communes — sécurisation tertiaire",
    tagline: "Tours, bureaux & interventions hors horaires",
    heroSubtitle: "La Défense n'est pas une commune administrative mais un quartier d'affaires réparti sur plusieurs villes. Nous y intervenons pour la sécurisation de bureaux, tours, et locaux tertiaires, y compris en horaires décalés.",
    intro:
      "Le quartier d'affaires de La Défense chevauche Puteaux et Courbevoie. Il abrite des tours de bureaux, des commerces (centre commercial Les 4 Temps, CNIT), et des accès sécurisés à plusieurs niveaux (voirie basse, dalle piétonne, parkings souterrains). Notre service y répond à des demandes très spécifiques : ouverture d'accès en dehors des horaires du gardiennage, changement de cylindres organigrammés, reprogrammation de badges, sécurisation post-incident.",
    contextLocal:
      "Nous intervenons sur la dalle et dans les tours (Coeur Défense, First, Majunga, T1…) ainsi que dans les immeubles adjacents. Nos équipes travaillent en soirée, week-end et jours fériés pour minimiser l'impact sur l'activité des entreprises. Nous établissons des contrats-cadres pour les grands utilisateurs qui souhaitent un interlocuteur unique.",
    servicesFocus: ["controle-acces", "changement-serrure", "blindage", "vitrerie", "ouverture-porte", "volets"],
    limitrophes: ["puteaux", "courbevoie", "nanterre", "neuilly-sur-seine"],
    image: "/images/villes/la-defense.webp",
    imageWidth: 879,
    imageHeight: 586,
    imageAlt: "Vue du quartier d'affaires de La Défense, Hauts-de-Seine, zone d'intervention DS Serrurier",
    seoTitle: "Serrurier La Défense (92800) 7j/7 | DS Serrurier",
    seoDescription: "Serrurier à La Défense (92800) : quartier d'affaires multi-communes, sécurisation tertiaire. Ouverture, blindage, vitrerie, volets. Devis gratuit.",
    servicesIntro: "En dehors des horaires de gardiennage, nos 4 domaines répondent aux besoins spécifiques des tours et bureaux.",
    servicesNotes: {
      "serrurerie-securite": "Ouverture d'accès et cylindres organigrammés pour tours et bureaux.",
      "vitrerie": "Vitrage de sécurité pour locaux tertiaires et commerces de la dalle.",
      "volets-roulants": "Dépannage de fermetures motorisées sur locaux commerciaux.",
      "controle-acces": "Badges, digicodes et reprogrammation pour un usage professionnel intensif.",
    },
    ctaLine: "Interventions possibles en soirée, week-end et jours fériés.",
    situations: [
      { titre: "Logements des tours résidentielles", texte: "Ouverture de porte et remplacement de cylindre pour les habitants des tours et immeubles du quartier." },
      { titre: "Accès aux immeubles", texte: "Nous organisons l'intervention avec vous selon les règles d'accès de la résidence ou du bâtiment (badge, gardien, parking)." },
      { titre: "Serrures haute sécurité", texte: "Intervention sur les serrures multipoints et les cylindres de marques comme Fichet, fréquents sur les portes d'entrée." },
      { titre: "Bureaux et locaux tertiaires", texte: "Ouverture d'accès, changement de cylindres organigrammés et badges, y compris en dehors des horaires de bureau." },
    ],
    realisations: [
      {
        id: "la-defense-fichet-vertibar",
        titre: "Ouverture de porte et cylindre Fichet Vertibar S dans la tour Ève",
        lieu: "La Défense — tour Ève",
        probleme: "L'occupant d'un logement de la tour Ève ne pouvait plus accéder à son appartement, équipé d'une serrure haute sécurité Fichet Vertibar S.",
        solution: "Ouverture de la porte, puis remplacement du cylindre de la serrure Fichet.",
        resultat: "L'accès au logement est rétabli et le système de fermeture fonctionne normalement avec le nouveau cylindre.",
        precision: "Dans ce cas précis, l'intervention a été prise en charge à 100 % par l'assurance du client. La prise en charge dépend toujours de votre contrat : vérifiez-le auprès de votre assureur.",
        service: "serrurerie-securite",
        photos: [
          {
            src: "/images/realisations/la-defense-fichet-vertibar-porte",
            widths: [480, 750],
            width: 750,
            height: 1200,
            alt: "Porte d'entrée ouverte montrant le mécanisme multipoint de la serrure Fichet Vertibar S et son cylindre",
            legende: "Le mécanisme multipoint de la porte (clés floutées).",
          },
          {
            src: "/images/realisations/la-defense-fichet-vertibar-mecanisme",
            widths: [450],
            width: 450,
            height: 600,
            alt: "Boîtier de la serrure Fichet Vertibar S dans le chant de la porte, avec son cylindre",
            legende: "Le boîtier de la serrure et son cylindre.",
          },
        ],
      },
    ],
  },
  {
    slug: "boulogne-billancourt",
    nom: "Boulogne-Billancourt",
    codePostal: "92100",
    departement: "92",
    departementNom: "Hauts-de-Seine",
    angle: "Ville la plus peuplée des Hauts-de-Seine — habitat résidentiel dense",
    tagline: "Copropriétés & immeubles anciens",
    heroSubtitle: "Boulogne-Billancourt est la commune la plus peuplée du département. Nous y intervenons majoritairement sur un habitat résidentiel dense : grandes copropriétés, immeubles de standing et pavillons plus rares côté Silly-Gallieni.",
    intro:
      "Boulogne-Billancourt combine un parc résidentiel très dense (Marcel Sembat, Les Princes, Rothschild, Point du Jour) et un tissu urbain en pleine mutation depuis la reconversion des anciens terrains Renault de l'Île Seguin. Cette densité impose au serrurier une bonne maîtrise des systèmes de fermeture collectifs propres aux grandes copropriétés : portes palières blindées, digicodes d'entrée, interphonie, gestion de badges pour les résidences sécurisées.",
    contextLocal:
      "Nous intervenons dans tous les quartiers de Boulogne-Billancourt : Pont de Sèvres, Silly-Gallieni-Charras, Marcel Sembat, Les Princes, Rothschild, Point du Jour, ainsi qu'aux abords du parc de Billancourt et de l'Île Seguin. Nous travaillons régulièrement avec des syndics de copropriété pour la réfection ou la mise aux normes de systèmes de fermeture collectifs.",
    servicesFocus: ["ouverture-porte", "changement-serrure", "blindage", "controle-acces", "vitrerie", "volets"],
    limitrophes: ["suresnes", "paris"],
    image: "/images/villes/boulogne-billancourt.webp",
    imageWidth: 1600,
    imageHeight: 1200,
    imageAlt: "Vue de la ville de Boulogne-Billancourt, Hauts-de-Seine, zone d'intervention DS Serrurier",
    seoTitle: "Serrurier Boulogne-Billancourt 7j/7 | DS Serrurier",
    seoDescription: "Serrurier à Boulogne-Billancourt (92100) : ville la plus peuplée du 92, habitat dense. Ouverture, blindage, vitrerie, volets. Devis gratuit.",
    servicesIntro: "Adaptés aux grandes copropriétés boulonnaises, nos 4 domaines couvrent tout l'habitat collectif dense.",
    servicesNotes: {
      "serrurerie-securite": "Ouverture et blindage pour portes palières d'immeubles collectifs.",
      "vitrerie": "Vitre cassée ou vitrage de sécurité pour appartements et halls d'immeuble.",
      "volets-roulants": "Dépannage de volet pour résidences et immeubles de standing.",
      "controle-acces": "Digicodes, interphonie et badges pour grandes copropriétés.",
    },
    ctaLine: "Un serrurier habitué aux grandes résidences du secteur.",
  },
  {
    slug: "paris",
    nom: "Paris",
    codePostal: "75",
    departement: "75",
    departementNom: "Paris",
    angle: "Tout Paris intra-muros, avec des délais courts sur l'ouest parisien",
    tagline: "Toute la capitale, un seul interlocuteur",
    heroSubtitle: "Nous intervenons dans tout Paris intra-muros, en urgence comme sur projet planifié.",
    intro:
      "Paris présente une grande variété de configurations : immeubles haussmanniens avec portes cochères et gardiens, résidences récentes sécurisées par badge, petites copropriétés sans concierge. Depuis notre base de Puteaux, à quelques minutes du périphérique ouest, nous couvrons l'ensemble des arrondissements avec une attention particulière portée à la préservation des menuiseries anciennes lors des interventions.",
    contextLocal:
      "Notre proximité avec La Défense et les portes ouest (Maillot, Champerret, Auteuil) rend les trajets plus courts vers les arrondissements de l'ouest parisien (16e, 17e) et une couverture adaptée sur le reste de la capitale. Nous travaillons aussi bien avec des particuliers qu'avec des gardiens d'immeuble et des syndics.",
    servicesFocus: ["ouverture-porte", "changement-serrure", "blindage", "controle-acces", "vitrerie", "volets"],
    limitrophes: ["neuilly-sur-seine", "boulogne-billancourt"],
    image: "/images/villes/paris.webp",
    imageWidth: 1333,
    imageHeight: 750,
    imageAlt: "Vue de Paris avec la tour Eiffel, zone d'intervention DS Serrurier",
    seoTitle: "Serrurier Paris (75) — Urgence 7j/7 | DS Serrurier",
    seoDescription: "Serrurier à Paris (75) : intervention dans tous les arrondissements, délais courts sur le 16e et le 17e. Ouverture, blindage, vitrerie. Devis gratuit.",
    servicesIntro: "De l'immeuble haussmannien à la petite copropriété, nos 4 domaines s'adaptent à Paris intra-muros.",
    servicesNotes: {
      "serrurerie-securite": "Ouverture et blindage respectueux des menuiseries anciennes parisiennes.",
      "vitrerie": "Vitre brisée ou vitrage de sécurité pour appartements et commerces.",
      "volets-roulants": "Dépannage de volet pour tous types de logements parisiens.",
      "controle-acces": "Digicodes et badges pour immeubles avec ou sans gardien.",
    },
    ctaLine: "Depuis l'ouest parisien, nous intervenons dans toute la capitale.",
  },
  {
    slug: "issy-les-moulineaux",
    nom: "Issy-les-Moulineaux",
    codePostal: "92130",
    departement: "92",
    departementNom: "Hauts-de-Seine",
    angle: "Ville en pleine mutation — sécuriser aussi bien les immeubles récents que le centre ancien",
    tagline: "Quartiers neufs & centre historique",
    heroSubtitle: "Issy-les-Moulineaux combine des quartiers résidentiels construits ces vingt dernières années et un centre-ville plus ancien. Nous adaptons notre intervention aux digicodes et badges des résidences récentes comme aux serrures plus classiques du centre.",
    intro:
      "À Issy-les-Moulineaux, le profil du bâti a beaucoup changé avec le développement des quartiers du bord de Seine et la densification résidentielle autour du centre-ville. Les programmes immobiliers récents arrivent généralement équipés de digicodes, de badges ou d'interphonie vidéo, pendant que le centre ancien conserve un parc de serrures et de portes plus traditionnel. Nous intervenons sur ces deux réalités : dépannage et paramétrage des systèmes de contrôle d'accès des immeubles récents, changement de serrure ou blindage sur les bâtiments plus anciens.",
    contextLocal:
      "Nos interventions couvrent tous les quartiers d'Issy-les-Moulineaux : les programmes récents du Fort d'Issy et des Hauts d'Issy, le secteur Val de Seine en bordure du fleuve, ainsi que le centre-ville historique et ses abords. Nous travaillons aussi bien avec des syndics de résidences récentes équipées de contrôle d'accès qu'avec des propriétaires de logements plus anciens du centre.",
    servicesFocus: ["controle-acces", "ouverture-porte", "changement-serrure", "blindage", "vitrerie", "volets"],
    limitrophes: ["boulogne-billancourt", "paris"],
    image: "/images/villes/issy-les-moulineaux.webp",
    imageWidth: 1536,
    imageHeight: 1024,
    imageAlt: "Vue d'Issy-les-Moulineaux, Hauts-de-Seine, zone d'intervention DS Serrurier",
    seoTitle: "Serrurier Issy-les-Moulineaux (92130) | DS Serrurier",
    seoDescription: "Serrurier à Issy-les-Moulineaux (92130) : résidences récentes et centre ancien, contrôle d'accès et serrurerie classique. Ouverture, blindage, vitrerie. Devis gratuit.",
    servicesIntro: "Du digicode de résidence récente à la serrure classique du centre ancien, nos 4 domaines s'adaptent au bâti d'Issy-les-Moulineaux.",
    servicesNotes: {
      "serrurerie-securite": "Changement de serrure et blindage pour les logements du centre ancien et les secteurs pavillonnaires.",
      "vitrerie": "Vitre cassée ou vitrage de sécurité, pour appartements récents comme logements plus anciens.",
      "volets-roulants": "Dépannage et motorisation de volets, quel que soit l'âge de votre résidence.",
      "controle-acces": "Digicodes, badges et interphonie vidéo pour les résidences récentes du Fort d'Issy et du Val de Seine.",
    },
    ctaLine: "Immeuble récent ou logement ancien : nous nous adaptons à votre installation.",
  },
  {
    slug: "rueil-malmaison",
    nom: "Rueil-Malmaison",
    codePostal: "92500",
    departement: "92",
    departementNom: "Hauts-de-Seine",
    angle: "Grande ville résidentielle — sécuriser un logement à l'arrivée d'un nouvel occupant",
    tagline: "Emménagement & changement de serrure",
    heroSubtitle: "Rueil-Malmaison est l'une des plus grandes villes des Hauts-de-Seine, avec un habitat très varié : pavillons du secteur Buzenval, grands ensembles du Plateau, immeubles du centre-ville. Nous recommandons systématiquement de changer la serrure à l'arrivée dans un nouveau logement, qu'il soit acheté ou loué.",
    intro:
      "Rueil-Malmaison réunit des types d'habitat très différents selon les quartiers : pavillons avec jardin à Buzenval, grands ensembles collectifs au Plateau, immeubles plus denses autour du centre-ville et du parc de Bois-Préau. Quel que soit le secteur, un principe reste valable à chaque emménagement : l'ancien occupant, locataire ou propriétaire précédent, a pu conserver un jeu de clés. Changer la serrure ou reprogrammer le cylindre à l'entrée dans le logement est une précaution simple que nous proposons systématiquement, en complément d'un diagnostic de sécurité gratuit.",
    contextLocal:
      "Nous intervenons dans tous les quartiers de Rueil-Malmaison : Buzenval, Le Plateau, Rueil-Centre, Mont-Valérien et les abords du parc de Bois-Préau et du château de la Malmaison. Nous proposons un changement de cylindre A2P rapide pour tout nouvel emménagement, ainsi que les diagnostics de sécurité habituels (porte, volets, accès à l'immeuble).",
    servicesFocus: ["changement-serrure", "ouverture-porte", "blindage", "controle-acces", "vitrerie", "volets"],
    limitrophes: ["nanterre", "suresnes", "chatou"],
    image: "/images/villes/rueil-malmaison.webp",
    imageWidth: 1536,
    imageHeight: 1024,
    imageAlt: "Vue de Rueil-Malmaison, Hauts-de-Seine, zone d'intervention DS Serrurier",
    seoTitle: "Serrurier Rueil-Malmaison (92500) | DS Serrurier",
    seoDescription: "Serrurier à Rueil-Malmaison (92500) : changement de serrure à l'emménagement, pavillons et grands ensembles. Ouverture, blindage, vitrerie, volets. Devis gratuit.",
    servicesIntro: "À chaque emménagement ou besoin ponctuel, nos 4 domaines couvrent l'ensemble des quartiers rueillois.",
    servicesNotes: {
      "serrurerie-securite": "Changement de cylindre A2P recommandé à chaque nouvel emménagement, à Buzenval comme au Plateau.",
      "vitrerie": "Vitre cassée ou vitrage de sécurité pour pavillons et appartements.",
      "volets-roulants": "Dépannage et motorisation de volets sur maison individuelle ou grand ensemble.",
      "controle-acces": "Digicodes et badges pour les résidences collectives du Plateau et du centre-ville.",
    },
    ctaLine: "Vous venez d'emménager ? Parlons sécurité dès aujourd'hui.",
  },
  {
    slug: "chatou",
    nom: "Chatou",
    codePostal: "78400",
    departement: "78",
    departementNom: "Yvelines",
    angle: "Un habitat pavillonnaire au bord de Seine",
    tagline: "Maisons de bord de Seine",
    heroSubtitle: "Commune pavillonnaire au bord de la Seine, connue pour son île et son histoire liée aux guinguettes, elle compte de nombreuses maisons individuelles proches du fleuve.",
    intro:
      "Chatou est une commune résidentielle structurée autour de la Seine et de son île, longtemps associée aux guinguettes et à l'histoire de la peinture impressionniste. Le bâti y est majoritairement pavillonnaire, avec des maisons parfois anciennes situées à proximité directe du fleuve. Sur ce type de logement, l'humidité ambiante en bord de Seine peut à la longue faire travailler les portes et menuiseries, ce qui dérègle le jeu d'une serrure ou le fonctionnement d'un volet. Nous intervenons sur ce type de désordre comme sur toute urgence classique.",
    contextLocal:
      "Nous couvrons Chatou dans son ensemble : les quartiers proches des quais et de l'île, le centre-ville, et les secteurs pavillonnaires plus en retrait du fleuve. Nos techniciens sont attentifs aux conséquences de l'humidité sur les menuiseries anciennes, fréquentes dans ce type de commune riveraine.",
    servicesFocus: ["ouverture-porte", "changement-serrure", "blindage", "volets", "vitrerie", "controle-acces"],
    limitrophes: ["rueil-malmaison"],
    image: "/images/villes/chatou.webp",
    imageWidth: 1536,
    imageHeight: 1024,
    imageAlt: "Vue de Chatou, Yvelines, zone d'intervention DS Serrurier",
    seoTitle: "Serrurier Chatou (78400) | DS Serrurier",
    seoDescription: "Serrurier à Chatou (78400) : maisons de bord de Seine, entretien des menuiseries exposées à l'humidité. Ouverture, blindage, vitrerie, volets. Devis gratuit.",
    servicesIntro: "En bord de Seine comme dans les secteurs plus en retrait, nos 4 domaines couvrent tout Chatou.",
    servicesNotes: {
      "serrurerie-securite": "Ouverture, blindage et réglage de serrures affectées par le jeu des menuiseries en bord de fleuve.",
      "vitrerie": "Vitre cassée ou vitrage de sécurité pour les maisons du secteur.",
      "volets-roulants": "Dépannage de volet, notamment lorsque l'humidité fait travailler le coffre ou les coulisses.",
      "controle-acces": "Digicode et interphone pour sécuriser l'accès à votre propriété.",
    },
    ctaLine: "Une porte ou un volet qui coince près de l'eau ? Appelez-nous pour un délai estimé.",
  },
];

export const findVille = (slug) => VILLES.find((v) => v.slug === slug);
